angular.module('nv.singleStudent').component('studentRegentsPanelOntrackStatus', {
  // tslint:disable-next-line:max-line-length
  template: require('.//student-regents-panel-ontrack-status.html'),
  bindings: {
    student: '<',
  },
  controller: 'StudentRegentsPanelOntrackStatusCtrl',
});
